import { AnimatedIconName } from 'components/AnimatedIcon/AnimatedIconName';
import { Button } from 'components/Button/Button';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';
import { REACTIONS } from 'modules/cms/constants/reactions';

import { CmsReactionButtonContainer } from './CmsReactionButton.styled';
import { CmsReactionButtonTooltip } from './CmsReactionButtonTooltip';
import { useCmsReactionsContext } from './CmsReactionsContext';

type Props = {
  onReactionClick: (reactionType: CmsApiReactionType) => void;
};

export function CmsReactionButton({ onReactionClick }: Props) {
  const { ownReaction } = useCmsReactionsContext();

  return (
    <Tooltip
      content={<CmsReactionButtonTooltip onClickReaction={onReactionClick} />}
      size="small"
      variant="filled"
      placement="top-center"
      animate
    >
      <CmsReactionButtonContainer
        data-qa-id="cms-reaction-button"
        data-qa-reaction-status={ownReaction?.reactionType}
      >
        <Button
          fullWidth
          variant={
            ownReaction?.reactionType
              ? REACTIONS[ownReaction.reactionType].buttonVariant
              : 'secondary'
          }
          icon={
            ownReaction?.reactionType
              ? {
                  type: 'animated',
                  name: ownReaction.reactionType.toLowerCase() as AnimatedIconName,
                  options: { maxLoopCount: 2 },
                }
              : {
                  type: 'normalized',
                  name: 'thumbs-up',
                }
          }
        >
          {ownReaction?.reactionType
            ? REACTIONS[ownReaction.reactionType].text
            : getText('Like')}
        </Button>
      </CmsReactionButtonContainer>
    </Tooltip>
  );
}
